import React from 'react'

const ExampleModal:React.FC = () => (<h1>{'Example'}</h1>)

export default ExampleModal
